/**
 *
 * @param s A string
 * @returns A string
 *
 * Capitalizes the first letter of the inputted string
 */
export function capitalize(s: string): string {
    return s && String(s[0]).toUpperCase() + String(s).slice(1);
}
